//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UiMixin from '@app/Filters/mixins/UiMixin';

const ATTRIBUTES_FOR_SEARCH_COUNT = 20

export default {
  mixins: [UiMixin],
  props: [
    'isDesktop',
    'disabled',
    'value',
    'filters',
    'available',
    'prices',
    'pagination',
  ],
  ATTRIBUTES_FOR_SEARCH_COUNT,
  data() {
    return {
      search: '',
      search_filter: {
        label: 'search',
        title: this._('Поиск'),
        id: 'search_id',
      },
      h: 0,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.setH)
  },
  methods: {
    setH() {
      const value = window.innerHeight - 74 - 52;
      const t = document.querySelector('div[data-modal="filters-modal"]')
      if (t && value !== this.h) {
        const [r] = t.getElementsByClassName('filter-wrap')
        r.parentElement.style.height = `${value}px`
        this.h = value
      }
    },
    getH() {
      const value = window.innerHeight - 74 - 52;
      return `${value}px`
    },
    toggleF(fn) {
      const isMob = 1200 > window.innerWidth
      const app = document.getElementById('app')
      if (isMob) app.dataset.blocked = false
      fn()
      if (!isMob) return
      window.scrollTo(window.scrollX, window.scrollY - 1)
      window.scrollTo(window.scrollX, window.scrollY + 1)
      app.dataset.blocked = true
    },
    modalClose(key) {
      this.$modal.hide(key)
      const app = document.getElementById('app')
      app.dataset.blocked = false
    },
  },
};
